/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/**
 * Product Card Images Web Component
 * Custom element that handles swiper initialization for product images
 */
var ProductCardImages = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ProductCardImages, _HTMLElement);
  var _super = _createSuper(ProductCardImages);
  function ProductCardImages() {
    var _this;
    _classCallCheck(this, ProductCardImages);
    _this = _super.call(this);
    _this.swiper = null;
    _this.isMobile = window.innerWidth < 768;
    return _this;
  }
  _createClass(ProductCardImages, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      // Only initialize if this element has slideshow or swiper behavior
      var hoverBehavior = this.getAttribute('data-hover-behavior');
      if (hoverBehavior === 'swiper') {
        this.initSwiper();
        this.bindEvents();
      }
    }
  }, {
    key: "initSwiper",
    value: function initSwiper() {
      var _this2 = this;
      // Wait for Swiper to be available
      if (typeof Swiper === 'undefined') {
        setTimeout(function () {
          return _this2.initSwiper();
        }, 100);
        return;
      }

      // Check if already initialized
      if (this.swiper) return;
      var swiperConfig = {
        slidesPerView: 1,
        spaceBetween: 2,
        loop: false,
        autoplay: false,
        effect: 'slide',
        speed: 300,
        touchRatio: 1,
        threshold: 10,
        allowTouchMove: true,
        grabCursor: true
      };

      // Add pagination for mobile
      if (this.isMobile) {
        var paginationEl = this.querySelector('.swiper-pagination');
        if (paginationEl) {
          swiperConfig.pagination = {
            el: paginationEl,
            clickable: true,
            type: 'bullets'
          };
        }
      }

      // Initialize Swiper on this element
      this.swiper = new Swiper(this, swiperConfig);
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this3 = this;
      // Handle resize
      this.resizeHandler = function () {
        var newIsMobile = window.innerWidth < 768;
        if (newIsMobile !== _this3.isMobile) {
          _this3.isMobile = newIsMobile;
          _this3.reinitialize();
        }
      };
      window.addEventListener('resize', this.resizeHandler);
    }
  }, {
    key: "reinitialize",
    value: function reinitialize() {
      var _this4 = this;
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      setTimeout(function () {
        _this4.initSwiper();
      }, 100);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
      }
    }
  }]);
  return ProductCardImages;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element
customElements.define('product-card-images', ProductCardImages);

// Handle AJAX loaded content
document.addEventListener('ajaxinate:loaded', function () {
  // Web components will auto-initialize when added to DOM
});

// Global function for manual reinitialization
window.reinitProductCardImages = function () {
  document.querySelectorAll('product-card-images').forEach(function (element) {
    if (element.reinitialize) {
      element.reinitialize();
    }
  });
};

/**
 * Shared Cart State Manager
 * Prevents multiple cart fetches on page load
 */
var B2BCartCache = {
  data: null,
  promise: null,
  getCart: function getCart() {
    var _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!_this5.promise) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", _this5.promise);
          case 2:
            if (!_this5.data) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", _this5.data);
          case 4:
            // Fetch cart and cache the promise
            _this5.promise = fetch('/cart.js').then(function (response) {
              return response.json();
            }).then(function (cart) {
              _this5.data = cart;
              _this5.promise = null;
              return cart;
            })["catch"](function (error) {
              console.error('Failed to fetch cart:', error);
              _this5.promise = null;
              return {
                items: []
              };
            });
            return _context.abrupt("return", _this5.promise);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  invalidate: function invalidate() {
    this.data = null;
    this.promise = null;
  },
  updateCache: function updateCache(cart) {
    this.data = cart;
  }
};

/**
 * B2B Add to Cart Component
 * Starts as "Add to Cart" button, transforms to quantity controls after first add
 * +/- buttons directly update cart
 */
var B2BAddToCart = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(B2BAddToCart, _HTMLElement2);
  var _super2 = _createSuper(B2BAddToCart);
  function B2BAddToCart() {
    var _this6;
    _classCallCheck(this, B2BAddToCart);
    _this6 = _super2.call(this);
    _this6.variantId = _this6.getAttribute('data-variant-id');
    _this6.productId = _this6.getAttribute('data-product-id');
    _this6.minQty = parseInt(_this6.getAttribute('data-min-qty')) || 1;
    _this6.maxQty = parseInt(_this6.getAttribute('data-max-qty')) || null;
    _this6.increment = parseInt(_this6.getAttribute('data-increment')) || 1;
    _this6.productTitle = _this6.getAttribute('data-product-title') || 'Product';
    _this6.showPrice = _this6.getAttribute('data-show-price') === 'true';
    _this6.variantPrice = _this6.getAttribute('data-variant-price') || '';
    _this6.comparePrice = _this6.getAttribute('data-compare-price') || '';
    _this6.buttonColor = _this6.getAttribute('data-button-color') || '';
    _this6.buttonStyle = _this6.getAttribute('data-button-style') || '';
    _this6.buttonSize = _this6.getAttribute('data-button-size') || '';
    _this6.isPDP = _this6.classList.contains('b2b-add-to-cart--pdp');
    _this6.isAvailable = _this6.getAttribute('data-available') === 'true';
    _this6.cartQty = 0; // Current quantity in cart for this variant
    _this6.isLoading = false;
    _this6.isInCart = false;
    _this6.inputDebounceTimeout = null; // For debouncing manual input

    // Listen for cart sync events from theme (only once per instance)
    _this6.handleCartSync = _this6.handleCartSync.bind(_assertThisInitialized(_this6));
    document.addEventListener('theme:cart:sync', _this6.handleCartSync);
    _this6.init();
    return _this6;
  }

  /**
   * Handle cart sync events from theme cart updates
   * Updates button state when cart changes from elsewhere
   */
  _createClass(B2BAddToCart, [{
    key: "handleCartSync",
    value: function () {
      var _handleCartSync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        var _event$detail,
          _this7 = this;
        var cart, cartItem, oldQty;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.isLoading) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              // Skip if currently processing an action
              cart = (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.cart;
              if (cart) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              // Update cache with fresh cart data
              B2BCartCache.updateCache(cart);

              // Find this variant in the updated cart
              cartItem = cart.items.find(function (item) {
                return item.variant_id == _this7.variantId;
              });
              oldQty = this.cartQty;
              if (cartItem) {
                this.cartQty = cartItem.quantity;
                this.isInCart = true;
              } else {
                this.cartQty = 0;
                this.isInCart = false;
              }

              // Only re-render if quantity actually changed
              if (oldQty !== this.cartQty) {
                this.render();
                this.bindEvents();
              }
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleCartSync(_x) {
        return _handleCartSync.apply(this, arguments);
      }
      return handleCartSync;
    }()
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // Clean up event listener when component is removed
      document.removeEventListener('theme:cart:sync', this.handleCartSync);

      // Clear any pending debounce timeout
      if (this.inputDebounceTimeout) {
        clearTimeout(this.inputDebounceTimeout);
      }
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.checkCartQuantity();
            case 2:
              this.render();
              this.bindEvents();
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "checkCartQuantity",
    value: function () {
      var _checkCartQuantity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this8 = this;
        var cart, cartItem;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return B2BCartCache.getCart();
            case 3:
              cart = _context4.sent;
              // Find this variant in cart
              cartItem = cart.items.find(function (item) {
                return item.variant_id == _this8.variantId;
              });
              if (cartItem) {
                this.cartQty = cartItem.quantity;
                this.isInCart = true;
              } else {
                this.cartQty = 0;
                this.isInCart = false;
              }
              _context4.next = 13;
              break;
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              console.error('Failed to check cart:', _context4.t0);
              this.cartQty = 0;
              this.isInCart = false;
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 8]]);
      }));
      function checkCartQuantity() {
        return _checkCartQuantity.apply(this, arguments);
      }
      return checkCartQuantity;
    }()
  }, {
    key: "render",
    value: function render() {
      // If sold out, show sold out button
      if (!this.isAvailable) {
        this.renderSoldOut();
        return;
      }
      if (this.isInCart) {
        // Show quantity controls (using div to allow nested buttons)
        if (this.isPDP) {
          // PDP version with theme button styling
          var btnClasses = "btn ".concat(this.buttonColor, " ").concat(this.buttonStyle, " ").concat(this.buttonSize, " btn--advanced btn--submit product__submit__add b2b-pdp-qty-controls");
          this.innerHTML = "\n          <div class=\"".concat(btnClasses, "\">\n            <button type=\"button\" class=\"b2b-pdp-qty-btn b2b-qty-minus\" aria-label=\"Remove ").concat(this.increment, " from cart\">\n              <svg width=\"12\" height=\"2\" viewBox=\"0 0 12 2\" fill=\"none\">\n                <path d=\"M0 1H12\" stroke=\"currentColor\" stroke-width=\"2\"/>\n              </svg>\n            </button>\n            <input type=\"number\" class=\"b2b-pdp-qty-input\" value=\"").concat(this.cartQty, "\" min=\"").concat(this.minQty, "\" ").concat(this.maxQty ? "max=\"".concat(this.maxQty, "\"") : '', " step=\"").concat(this.increment, "\" aria-label=\"Quantity\">\n            <button type=\"button\" class=\"b2b-pdp-qty-btn b2b-qty-plus\" aria-label=\"Add ").concat(this.increment, " to cart\">\n              <svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\">\n                <path d=\"M6 0V12M0 6H12\" stroke=\"currentColor\" stroke-width=\"2\"/>\n              </svg>\n            </button>\n            <span class=\"b2b-btn-loader\">\n              <em class=\"loader loader--line\"><em class=\"loader-indeterminate\"></em></em>\n            </span>\n          </div>\n          <div class=\"b2b-error-message\" role=\"alert\"></div>\n        ");
        } else {
          // Collection grid version (original styling)
          this.innerHTML = "\n          <div class=\"b2b-add-to-cart-btn b2b-qty-controls\">\n            <button type=\"button\" class=\"b2b-qty-btn b2b-qty-minus\" aria-label=\"Remove ".concat(this.increment, " from cart\">\n              <svg width=\"12\" height=\"2\" viewBox=\"0 0 12 2\" fill=\"none\">\n                <path d=\"M0 1H12\" stroke=\"currentColor\" stroke-width=\"2\"/>\n              </svg>\n            </button>\n            <input type=\"number\" class=\"b2b-qty-input\" value=\"").concat(this.cartQty, "\" min=\"").concat(this.minQty, "\" ").concat(this.maxQty ? "max=\"".concat(this.maxQty, "\"") : '', " step=\"").concat(this.increment, "\" aria-label=\"Quantity\">\n            <button type=\"button\" class=\"b2b-qty-btn b2b-qty-plus\" aria-label=\"Add ").concat(this.increment, " to cart\">\n              <svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\">\n                <path d=\"M6 0V12M0 6H12\" stroke=\"currentColor\" stroke-width=\"2\"/>\n              </svg>\n            </button>\n            <span class=\"b2b-btn-loader\">\n              <svg height=\"18\" width=\"18\" class=\"svg-loader\">\n                <circle r=\"7\" cx=\"9\" cy=\"9\" />\n                <circle stroke-dasharray=\"87.96459430051421 87.96459430051421\" r=\"7\" cx=\"9\" cy=\"9\" />\n              </svg>\n            </span>\n          </div>\n          <div class=\"b2b-error-message\" role=\"alert\"></div>\n        ");
        }
      } else {
        // Show add to cart button
        var priceHTML = '';
        if (this.showPrice && this.variantPrice) {
          priceHTML = "<span data-product-price class=\"product__price--regular\">".concat(this.variantPrice, "</span>");
          if (this.comparePrice) {
            priceHTML += "<s data-compare-price class=\"product__price--compare\">".concat(this.comparePrice, "</s>");
          }
        }
        if (this.isPDP) {
          // PDP version with theme button styling
          var _btnClasses = "btn ".concat(this.buttonColor, " ").concat(this.buttonStyle, " ").concat(this.buttonSize, " btn--advanced btn--submit product__submit__add b2b-pdp-add-btn");
          this.innerHTML = "\n          <button type=\"button\" class=\"".concat(_btnClasses, "\">\n            <hover-button></hover-button>\n            <span class=\"b2b-btn-text\">\n              <em>Add to Cart</em>").concat(priceHTML, "\n            </span>\n            <span class=\"b2b-btn-loader\">\n              <em class=\"loader loader--line\"><em class=\"loader-indeterminate\"></em></em>\n            </span>\n          </button>\n          <div class=\"b2b-error-message\" role=\"alert\"></div>\n        ");
        } else {
          // Collection grid version (original styling)
          this.innerHTML = "\n          <button type=\"button\" class=\"b2b-add-to-cart-btn\">\n            <span class=\"b2b-btn-text\">Add to Cart</span>\n            <span class=\"b2b-btn-loader\">\n              <svg height=\"18\" width=\"18\" class=\"svg-loader\">\n                <circle r=\"7\" cx=\"9\" cy=\"9\" />\n                <circle stroke-dasharray=\"87.96459430051421 87.96459430051421\" r=\"7\" cx=\"9\" cy=\"9\" />\n              </svg>\n            </span>\n          </button>\n          <div class=\"b2b-error-message\" role=\"alert\"></div>\n        ";
        }
      }
    }
  }, {
    key: "renderSoldOut",
    value: function renderSoldOut() {
      if (this.isPDP) {
        var btnClasses = "btn ".concat(this.buttonColor, " ").concat(this.buttonStyle, " ").concat(this.buttonSize, " btn--advanced btn--submit product__submit__add b2b-pdp-sold-out");
        this.innerHTML = "\n        <button type=\"button\" class=\"".concat(btnClasses, "\" disabled>\n          <span class=\"b2b-btn-text\">\n            <em>Sold Out</em>\n          </span>\n        </button>\n      ");
      } else {
        this.innerHTML = "\n        <button type=\"button\" class=\"b2b-add-to-cart-btn b2b-sold-out\" disabled>\n          <span class=\"b2b-btn-text\">Sold Out</span>\n        </button>\n      ";
      }
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this9 = this;
      // Don't bind events if sold out
      if (!this.isAvailable) return;
      if (this.isInCart) {
        var minusBtn = this.querySelector('.b2b-qty-minus');
        var plusBtn = this.querySelector('.b2b-qty-plus');
        var qtyInput = this.querySelector('.b2b-qty-input, .b2b-pdp-qty-input');
        minusBtn === null || minusBtn === void 0 ? void 0 : minusBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          _this9.decreaseInCart();
        });
        plusBtn === null || plusBtn === void 0 ? void 0 : plusBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          _this9.increaseInCart();
        });

        // Handle manual quantity input with debouncing (like cart drawer)
        qtyInput === null || qtyInput === void 0 ? void 0 : qtyInput.addEventListener('input', function (e) {
          e.stopPropagation();

          // Clear previous timeout
          if (_this9.inputDebounceTimeout) {
            clearTimeout(_this9.inputDebounceTimeout);
          }

          // Set new timeout to trigger update after 800ms of no typing
          _this9.inputDebounceTimeout = setTimeout(function () {
            var newQty = parseInt(e.target.value);
            // Only proceed if we have a valid number
            if (!isNaN(newQty)) {
              _this9.updateQuantityManually(newQty);
            }
          }, 800);
        });

        // Trigger immediate update on Enter key
        qtyInput === null || qtyInput === void 0 ? void 0 : qtyInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();

            // Clear debounce and update immediately
            if (_this9.inputDebounceTimeout) {
              clearTimeout(_this9.inputDebounceTimeout);
            }
            var newQty = parseInt(e.target.value);
            if (!isNaN(newQty)) {
              _this9.updateQuantityManually(newQty);
            }
          }
        });
      } else {
        var addToCartBtn = this.querySelector('.b2b-add-to-cart-btn, .b2b-pdp-add-btn');
        addToCartBtn === null || addToCartBtn === void 0 ? void 0 : addToCartBtn.addEventListener('click', function () {
          return _this9.addToCart();
        });
      }
    }
  }, {
    key: "increaseInCart",
    value: function () {
      var _increaseInCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var response, error;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!this.isLoading) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              if (!(this.maxQty !== null && this.cartQty + this.increment > this.maxQty)) {
                _context5.next = 5;
                break;
              }
              this.showError("Maximum quantity is ".concat(this.maxQty));
              return _context5.abrupt("return");
            case 5:
              this.isLoading = true;
              this.setLoadingState(true);
              this.clearError();
              _context5.prev = 8;
              _context5.next = 11;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                  items: [{
                    id: this.variantId,
                    quantity: this.increment
                  }]
                })
              });
            case 11:
              response = _context5.sent;
              if (response.ok) {
                _context5.next = 17;
                break;
              }
              _context5.next = 15;
              return response.json();
            case 15:
              error = _context5.sent;
              throw new Error(error.description || 'Failed to update cart');
            case 17:
              // Update UI immediately for fast feedback
              this.cartQty += this.increment;
              this.updateQuantityDisplay();

              // Stop loading immediately
              this.isLoading = false;
              this.setLoadingState(false);

              // Refresh cart in background without blocking UI
              this.refreshCart();
              _context5.next = 29;
              break;
            case 24:
              _context5.prev = 24;
              _context5.t0 = _context5["catch"](8);
              this.showError(_context5.t0.message);
              this.isLoading = false;
              this.setLoadingState(false);
            case 29:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[8, 24]]);
      }));
      function increaseInCart() {
        return _increaseInCart.apply(this, arguments);
      }
      return increaseInCart;
    }()
  }, {
    key: "decreaseInCart",
    value: function () {
      var _decreaseInCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var newQty, response, error;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!this.isLoading) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              newQty = this.cartQty - this.increment; // If removing would bring us below min or to 0, remove from cart entirely
              if (!(newQty < this.minQty)) {
                _context6.next = 7;
                break;
              }
              _context6.next = 6;
              return this.removeFromCart();
            case 6:
              return _context6.abrupt("return");
            case 7:
              this.isLoading = true;
              this.setLoadingState(true);
              this.clearError();
              _context6.prev = 10;
              _context6.next = 13;
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                  id: this.variantId,
                  quantity: newQty
                })
              });
            case 13:
              response = _context6.sent;
              if (response.ok) {
                _context6.next = 19;
                break;
              }
              _context6.next = 17;
              return response.json();
            case 17:
              error = _context6.sent;
              throw new Error(error.description || 'Failed to update cart');
            case 19:
              // Update UI immediately for fast feedback
              this.cartQty = newQty;
              this.updateQuantityDisplay();

              // Stop loading immediately
              this.isLoading = false;
              this.setLoadingState(false);

              // Refresh cart in background without blocking UI
              this.refreshCart();
              _context6.next = 31;
              break;
            case 26:
              _context6.prev = 26;
              _context6.t0 = _context6["catch"](10);
              this.showError(_context6.t0.message);
              this.isLoading = false;
              this.setLoadingState(false);
            case 31:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[10, 26]]);
      }));
      function decreaseInCart() {
        return _decreaseInCart.apply(this, arguments);
      }
      return decreaseInCart;
    }()
  }, {
    key: "removeFromCart",
    value: function () {
      var _removeFromCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var response, error;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!this.isLoading) {
                _context7.next = 2;
                break;
              }
              return _context7.abrupt("return");
            case 2:
              this.isLoading = true;
              this.setLoadingState(true);
              this.clearError();
              _context7.prev = 5;
              _context7.next = 8;
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                  id: this.variantId,
                  quantity: 0
                })
              });
            case 8:
              response = _context7.sent;
              if (response.ok) {
                _context7.next = 14;
                break;
              }
              _context7.next = 12;
              return response.json();
            case 12:
              error = _context7.sent;
              throw new Error(error.description || 'Failed to remove from cart');
            case 14:
              // Update UI immediately for fast feedback
              this.cartQty = 0;
              this.isInCart = false;

              // Re-render to show "Add to Cart" button
              this.render();
              this.bindEvents();

              // Stop loading immediately
              this.isLoading = false;
              this.setLoadingState(false);

              // Refresh cart in background without blocking UI
              this.refreshCart();
              _context7.next = 28;
              break;
            case 23:
              _context7.prev = 23;
              _context7.t0 = _context7["catch"](5);
              this.showError(_context7.t0.message);
              this.isLoading = false;
              this.setLoadingState(false);
            case 28:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[5, 23]]);
      }));
      function removeFromCart() {
        return _removeFromCart.apply(this, arguments);
      }
      return removeFromCart;
    }()
  }, {
    key: "updateQuantityManually",
    value: function () {
      var _updateQuantityManually = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(newQty) {
        var _this10 = this;
        var input, resetInput, response, error;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!this.isLoading) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return");
            case 2:
              console.log('[B2B] updateQuantityManually called with:', {
                newQty: newQty,
                currentQty: this.cartQty,
                maxQty: this.maxQty,
                minQty: this.minQty,
                increment: this.increment
              });

              // Store reference to input to avoid repeated queries
              input = this.querySelector('.b2b-qty-input, .b2b-pdp-qty-input'); // Helper function to reset input without triggering events
              resetInput = function resetInput() {
                if (input) {
                  // Remove event listener temporarily to prevent re-triggering
                  var currentValue = input.value;
                  input.value = _this10.cartQty;
                  console.log('[B2B] Input reset from', currentValue, 'to', _this10.cartQty);
                }
              }; // Validate quantity
              if (!(isNaN(newQty) || newQty < 0)) {
                _context8.next = 10;
                break;
              }
              console.log('[B2B] Validation failed: Invalid quantity');
              this.showError('Please enter a valid quantity');
              resetInput();
              return _context8.abrupt("return");
            case 10:
              if (!(newQty === 0 || newQty < this.minQty)) {
                _context8.next = 14;
                break;
              }
              console.log('[B2B] Removing from cart: quantity below min');
              this.removeFromCart();
              return _context8.abrupt("return");
            case 14:
              if (!(this.maxQty !== null && newQty > this.maxQty)) {
                _context8.next = 19;
                break;
              }
              console.log('[B2B] Validation failed: Exceeds max quantity', newQty, '>', this.maxQty);
              this.showError("Maximum quantity is ".concat(this.maxQty));
              resetInput();
              return _context8.abrupt("return");
            case 19:
              if (!((newQty - this.minQty) % this.increment !== 0)) {
                _context8.next = 24;
                break;
              }
              console.log('[B2B] Validation failed: Invalid increment');
              this.showError("Quantity must be in increments of ".concat(this.increment));
              resetInput();
              return _context8.abrupt("return");
            case 24:
              if (!(newQty === this.cartQty)) {
                _context8.next = 27;
                break;
              }
              console.log('[B2B] No change needed: same quantity');
              return _context8.abrupt("return");
            case 27:
              console.log('[B2B] Validation passed, making API call');
              this.isLoading = true;
              this.setLoadingState(true);
              this.clearError();
              _context8.prev = 31;
              _context8.next = 34;
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                  id: this.variantId,
                  quantity: newQty
                })
              });
            case 34:
              response = _context8.sent;
              if (response.ok) {
                _context8.next = 40;
                break;
              }
              _context8.next = 38;
              return response.json();
            case 38:
              error = _context8.sent;
              throw new Error(error.description || 'Failed to update quantity');
            case 40:
              // Update local state immediately
              this.cartQty = newQty;

              // Stop loading and update UI immediately
              this.isLoading = false;
              this.setLoadingState(false);
              this.render();
              this.bindEvents();

              // Fire cart refresh event in background (without await)
              this.refreshCart();
              _context8.next = 56;
              break;
            case 48:
              _context8.prev = 48;
              _context8.t0 = _context8["catch"](31);
              console.error('Error updating quantity:', _context8.t0);
              this.showError(_context8.t0.message);
              this.isLoading = false;
              this.setLoadingState(false);
              this.render();
              this.bindEvents();
            case 56:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[31, 48]]);
      }));
      function updateQuantityManually(_x2) {
        return _updateQuantityManually.apply(this, arguments);
      }
      return updateQuantityManually;
    }()
  }, {
    key: "addToCart",
    value: function () {
      var _addToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var response, error;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!this.isLoading) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return");
            case 2:
              this.isLoading = true;
              this.setLoadingState(true);
              this.clearError();
              _context9.prev = 5;
              _context9.next = 8;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                  items: [{
                    id: this.variantId,
                    quantity: this.minQty
                  }]
                })
              });
            case 8:
              response = _context9.sent;
              if (response.ok) {
                _context9.next = 14;
                break;
              }
              _context9.next = 12;
              return response.json();
            case 12:
              error = _context9.sent;
              throw new Error(error.description || 'Failed to add to cart');
            case 14:
              // Update UI immediately for fast feedback
              this.cartQty = this.minQty;
              this.isInCart = true;

              // Wait briefly to show the spinner (minimum 300ms)
              _context9.next = 18;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 300);
              });
            case 18:
              // Re-render to show quantity controls
              this.render();
              this.bindEvents();

              // Stop loading immediately after render
              this.isLoading = false;
              this.setLoadingState(false);

              // Refresh cart in background without blocking UI
              this.refreshCart();
              _context9.next = 30;
              break;
            case 25:
              _context9.prev = 25;
              _context9.t0 = _context9["catch"](5);
              this.showError(_context9.t0.message);
              this.isLoading = false;
              this.setLoadingState(false);
            case 30:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[5, 25]]);
      }));
      function addToCart() {
        return _addToCart.apply(this, arguments);
      }
      return addToCart;
    }()
  }, {
    key: "updateQuantityDisplay",
    value: function updateQuantityDisplay() {
      // Update input fields (for new manual input version)
      var input = this.querySelector('.b2b-qty-input, .b2b-pdp-qty-input');
      if (input) {
        input.value = this.cartQty;
      }

      // Update display spans (for backward compatibility)
      var display = this.querySelector('.b2b-qty-display, .b2b-pdp-qty-display');
      if (display) {
        display.textContent = this.cartQty;
      }
    }
  }, {
    key: "refreshCart",
    value: function () {
      var _refreshCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var openDrawer,
          response,
          cart,
          cartCount,
          cartToggles,
          _args10 = arguments;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              openDrawer = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : false;
              _context10.prev = 1;
              _context10.next = 4;
              return fetch('/cart.js');
            case 4:
              response = _context10.sent;
              _context10.next = 7;
              return response.json();
            case 7:
              cart = _context10.sent;
              // Update the shared cache so other components can use it
              B2BCartCache.updateCache(cart);
              debugger;
              // Trigger theme cart update events
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                  cart: cart,
                  openDrawer: openDrawer
                }
              }));
              document.dispatchEvent(new CustomEvent('theme:cart:update', {
                detail: {
                  cart: cart,
                  openDrawer: openDrawer
                }
              }));

              // Trigger cart drawer/page refresh - pass openDrawer flag
              document.dispatchEvent(new CustomEvent('theme:cart:refresh-drawer', {
                bubbles: true,
                detail: {
                  cart: cart,
                  openDrawer: openDrawer
                }
              }));

              // Update cart count
              cartCount = document.querySelectorAll('[data-cart-count]');
              cartCount.forEach(function (el) {
                el.textContent = cart.item_count;
                // Show/hide cart count bubble based on item count
                if (cart.item_count > 0) {
                  el.classList.remove('hidden');
                } else {
                  el.classList.add('hidden');
                }
              });
              // Update cart toggle has-items class
              cartToggles = document.querySelectorAll('.cart__toggle');
              cartToggles.forEach(function (toggle) {
                if (cart.item_count > 0) {
                  toggle.classList.add('cart__toggle--has-items');
                } else {
                  toggle.classList.remove('cart__toggle--has-items');
                }
              });

              // Force Upcart to refresh its cart UI
              if (typeof window.upcartRefreshCart === 'function') {
                try {
                  window.upcartRefreshCart();
                  console.log('[B2B] Upcart cart refreshed');
                } catch (error) {
                  console.warn('[B2B] Error refreshing Upcart:', error);
                }
              }
              _context10.next = 23;
              break;
            case 20:
              _context10.prev = 20;
              _context10.t0 = _context10["catch"](1);
              console.error('Failed to refresh cart:', _context10.t0);
            case 23:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[1, 20]]);
      }));
      function refreshCart() {
        return _refreshCart.apply(this, arguments);
      }
      return refreshCart;
    }()
  }, {
    key: "setLoadingState",
    value: function setLoadingState(isLoading) {
      var container = this.querySelector('.b2b-add-to-cart-btn, .b2b-pdp-add-btn, .b2b-pdp-qty-controls');
      var loader = this.querySelector('.b2b-btn-loader');
      if (container) {
        // Only disable if it's a button element
        if (container.tagName === 'BUTTON') {
          container.disabled = isLoading;
        }
        container.classList.toggle('is-loading', isLoading);

        // Disable inner buttons if in quantity controls mode
        if (container.classList.contains('b2b-qty-controls') || container.classList.contains('b2b-pdp-qty-controls')) {
          var innerButtons = container.querySelectorAll('.b2b-qty-btn, .b2b-pdp-qty-btn');
          innerButtons.forEach(function (btn) {
            btn.disabled = isLoading;
          });
        }
      }
      if (loader) {
        loader.style.display = isLoading ? 'flex' : 'none';
      }

      // Hide text/controls during loading
      var text = this.querySelector('.b2b-btn-text');
      var controls = this.querySelectorAll('.b2b-qty-btn, .b2b-qty-display, .b2b-pdp-qty-btn, .b2b-pdp-qty-display, .b2b-qty-input, .b2b-pdp-qty-input');
      if (text) {
        text.style.opacity = isLoading ? '0' : '1';
      }
      controls.forEach(function (el) {
        el.style.opacity = isLoading ? '0' : '1';
      });
    }
  }, {
    key: "showError",
    value: function showError(message) {
      var _this11 = this;
      console.log('[B2B] showError called with:', message);
      var errorEl = this.querySelector('.b2b-error-message');
      console.log('[B2B] Error element found:', !!errorEl);
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.style.display = 'block';
        console.log('[B2B] Error displayed');
        setTimeout(function () {
          _this11.clearError();
        }, 5000);
      }
    }
  }, {
    key: "clearError",
    value: function clearError() {
      var errorEl = this.querySelector('.b2b-error-message');
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.style.display = 'none';
      }
    }
  }]);
  return B2BAddToCart;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element
customElements.define('b2b-add-to-cart', B2BAddToCart);

// Invalidate cart cache when cart is updated from elsewhere
document.addEventListener('cart:refresh', function () {
  B2BCartCache.invalidate();
});
document.addEventListener('theme:cart:update', function () {
  B2BCartCache.invalidate();
});

/**
 * Collection Top Filter Tabs Web Component
 * Compatible with existing collection-filters system
 */
var CollectionTopFilter = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(CollectionTopFilter, _HTMLElement3);
  var _super3 = _createSuper(CollectionTopFilter);
  function CollectionTopFilter() {
    var _this12;
    _classCallCheck(this, CollectionTopFilter);
    _this12 = _super3.call(this);
    _this12.sectionId = _this12.getAttribute('section-id');
    _this12.activeTags = new Set();
    _this12.collectionFilters = null;
    _this12.isUpdating = false;
    _this12.init();
    return _this12;
  }
  _createClass(CollectionTopFilter, [{
    key: "init",
    value: function () {
      var _init2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              try {
                // Find the main collection filters component
                this.collectionFilters = document.querySelector('collection-filters');
                this.initActiveStates();
                this.bindEvents();
              } catch (error) {
                console.warn('Error initializing CollectionTopFilter:', error);
              }
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function init() {
        return _init2.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initActiveStates",
    value: function initActiveStates() {
      var _this13 = this;
      var url = new URL(window.location.href);
      var tagParams = url.searchParams.getAll("filter.p.tag");
      var allButton = this.querySelector('.top-filter-button[data-tag="all"]');

      // Clear all active states first
      this.querySelectorAll(".top-filter-button").forEach(function (btn) {
        return btn.classList.remove("is-active");
      });

      // Clear and rebuild active tags
      this.activeTags.clear();
      if (tagParams.length > 0) {
        // Set active tags and update buttons
        tagParams.forEach(function (tag) {
          _this13.activeTags.add(tag);
          var button = _this13.querySelector(".top-filter-button[data-tag=\"".concat(tag, "\"]"));
          if (button) {
            button.classList.add("is-active");
          }
        });
      } else if (allButton) {
        // No tags active, show "all" as active
        allButton.classList.add("is-active");
      }
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this14 = this;
      this.querySelectorAll(".top-filter-button").forEach(function (button) {
        button.addEventListener("click", _this14.onFilterButtonClick.bind(_this14));
      });

      // Listen for collection filter updates to sync our state
      document.addEventListener('shopify:section:load', function () {
        setTimeout(function () {
          _this14.initActiveStates();
        }, 100);
      });

      // Listen for browser back/forward navigation
      window.addEventListener('popstate', function () {
        setTimeout(function () {
          _this14.initActiveStates();
        }, 100);
      });

      // Listen for collection filters updates if they exist
      if (this.collectionFilters) {
        // Override the collection filters renderSection to sync our state
        var originalRenderSection = this.collectionFilters.renderSection;
        if (originalRenderSection) {
          this.collectionFilters.renderSection = function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            var result = originalRenderSection.apply(_this14.collectionFilters, args);
            setTimeout(function () {
              _this14.initActiveStates();
            }, 200);
            return result;
          };
        }
      }
    }
  }, {
    key: "onFilterButtonClick",
    value: function onFilterButtonClick(event) {
      var _this15 = this;
      event.preventDefault();
      if (this.isUpdating) return;
      var button = event.currentTarget;
      var tagHandle = button.dataset.tag;
      var isAll = tagHandle === "all";
      var allButton = this.querySelector('.top-filter-button[data-tag="all"]');
      var selectionMode = this.dataset.selectionMode || 'single';

      // Add loading state
      this.addLoadingState(button);
      if (isAll) {
        // Clear all tags and show all products
        this.activeTags.clear();
        this.querySelectorAll(".top-filter-button").forEach(function (btn) {
          return btn.classList.remove("is-active");
        });
        button.classList.add("is-active");
      } else {
        if (selectionMode === 'single') {
          // Single selection mode (radio button behavior)
          if (button.classList.contains("is-active")) {
            // If clicking an already active button, show all products
            this.activeTags.clear();
            this.querySelectorAll(".top-filter-button").forEach(function (btn) {
              return btn.classList.remove("is-active");
            });
            if (allButton) allButton.classList.add("is-active");
          } else {
            // Deactivate all other buttons and activate only this one
            this.activeTags.clear();
            this.querySelectorAll(".top-filter-button").forEach(function (btn) {
              return btn.classList.remove("is-active");
            });
            this.activeTags.add(tagHandle);
            button.classList.add("is-active");
          }
        } else {
          // Multi selection mode (checkbox behavior)
          if (button.classList.contains("is-active")) {
            this.activeTags["delete"](tagHandle);
            button.classList.remove("is-active");
          } else {
            this.activeTags.add(tagHandle);
            button.classList.add("is-active");
          }

          // Update "all" button state for multi-select
          if (this.activeTags.size === 0) {
            if (allButton) allButton.classList.add("is-active");
          } else if (allButton) {
            allButton.classList.remove("is-active");
          }
        }
      }

      // Apply the filter
      this.applyFilters()["finally"](function () {
        _this15.removeLoadingState(button);
      });
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      var _this16 = this;
      return new Promise(function (resolve, reject) {
        _this16.isUpdating = true;
        var url = _this16.buildFilterUrl();

        // Use the existing collection filters system if available
        if (_this16.collectionFilters && _this16.collectionFilters.renderSection) {
          try {
            var searchParams = url.searchParams.toString();
            _this16.collectionFilters.renderSection(searchParams, null, true);

            // Wait for the DOM to update and then handle ajaxinate
            setTimeout(function () {
              _this16.handleAjaxinateAfterFilter();
              _this16.isUpdating = false;
              resolve();
            }, 600);
          } catch (error) {
            console.warn('Error in collection filters renderSection:', error);
            _this16.isUpdating = false;
            // Fallback to page reload on error
            window.location.href = url.toString();
            resolve();
          }
        } else {
          // Fallback to manual page reload
          window.location.href = url.toString();
          resolve();
        }
      })["finally"](function () {
        console.log('auto close');
        // Auto-close filters on mobile after search completes
        _this16.autoCloseFiltersOnMobile(200);
        _this16.autoCloseFiltersOnMobile(400);
      });
    }
  }, {
    key: "handleAjaxinateAfterFilter",
    value: function handleAjaxinateAfterFilter() {
      // Find ajaxinate elements and reinitialize them safely
      try {
        var ajaxinateElements = document.querySelectorAll('ajaxinate-items');
        ajaxinateElements.forEach(function (element) {
          if (element && typeof element.reinit === 'function') {
            // Small delay to ensure DOM is ready
            setTimeout(function () {
              try {
                element.reinit();
              } catch (error) {
                console.warn('Error reinitializing ajaxinate element:', error);
              }
            }, 100);
          }
        });

        // Auto-close filters on mobile after search completes
        this.autoCloseFiltersOnMobile();
      } catch (error) {
        console.warn('Error handling ajaxinate after filter:', error);
      }
    }
  }, {
    key: "autoCloseFiltersOnMobile",
    value: function autoCloseFiltersOnMobile() {
      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;
      // Only trigger on mobile devices
      if (window.innerWidth <= 768) {
        // Find the filters toggle button and click it to close the filters
        var filtersToggle = document.querySelector('.collection__filters__toggle');
        if (filtersToggle) {
          // Add a small delay to ensure the DOM has updated
          setTimeout(function () {
            try {
              filtersToggle.click();
            } catch (error) {
              console.warn('Error clicking filters toggle:', error);
            }
          }, delay);
        }
      }
    }
  }, {
    key: "buildFilterUrl",
    value: function buildFilterUrl() {
      var url = new URL(window.location.origin + window.location.pathname);
      var currentParams = new URLSearchParams(window.location.search);

      // Preserve non-tag filter parameters
      var _iterator = _createForOfIteratorHelper(currentParams.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            value = _step$value[1];
          if (!key.startsWith('filter.p.tag') && key !== 'page') {
            url.searchParams.append(key, value);
          }
        }

        // Add active tags
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.activeTags.forEach(function (tag) {
        url.searchParams.append("filter.p.tag", tag);
      });
      return url;
    }
  }, {
    key: "addLoadingState",
    value: function addLoadingState(button) {
      button.style.opacity = '0.6';
      button.style.pointerEvents = 'none';
      button.classList.add('loading');
    }
  }, {
    key: "removeLoadingState",
    value: function removeLoadingState(button) {
      button.style.opacity = '';
      button.style.pointerEvents = '';
      button.classList.remove('loading');
    }

    // Public method to refresh the component state
  }, {
    key: "refresh",
    value: function refresh() {
      try {
        // Re-find collection filters in case DOM changed
        this.collectionFilters = document.querySelector('collection-filters');
        this.initActiveStates();
      } catch (error) {
        console.warn('Error refreshing CollectionTopFilter:', error);
      }
    }
  }]);
  return CollectionTopFilter;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element
customElements.define("collection-top-filter", CollectionTopFilter);

/**
 * Simple Collection Visibility Toggle - CSS Based
 */
var CollectionVisibilityToggle = /*#__PURE__*/function (_HTMLElement4) {
  _inherits(CollectionVisibilityToggle, _HTMLElement4);
  var _super4 = _createSuper(CollectionVisibilityToggle);
  function CollectionVisibilityToggle() {
    var _this17;
    _classCallCheck(this, CollectionVisibilityToggle);
    _this17 = _super4.call(this);
    _this17.init();
    return _this17;
  }
  _createClass(CollectionVisibilityToggle, [{
    key: "init",
    value: function init() {
      this.addEventListener('click', this.handleClick.bind(this));

      // Get the default view from the currently selected button (set by Liquid template from settings)
      var defaultButton = this.querySelector('.is-selected');
      var defaultView = defaultButton ? defaultButton.dataset.view : '1';

      // Apply the default view from settings
      this.setView(defaultView);
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var target = event.target.closest('[data-view]');
      if (!target) return;
      var view = target.dataset.view;
      this.setView(view);
    }
  }, {
    key: "setView",
    value: function setView(view) {
      // Update toggle buttons
      this.querySelectorAll('[data-view]').forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.dataset.view === view);
      });

      // Update body class for CSS targeting
      document.body.className = document.body.className.replace(/mobile-grid-\d+/g, '');
      document.body.classList.add("mobile-grid-".concat(view));
    }
  }]);
  return CollectionVisibilityToggle;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("collection-visibility-toggle", CollectionVisibilityToggle);

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', function () {
  // Auto-refresh top filters when collection updates
  document.addEventListener('ajaxinate:loaded', function () {
    document.querySelectorAll('collection-top-filter').forEach(function (element) {
      if (element.refresh) {
        element.refresh();
      }
    });

    // Also refresh visibility toggles
    document.querySelectorAll('collection-visibility-toggle').forEach(function (element) {
      if (element.applyGridLayout) {
        element.applyGridLayout();
      }
    });
  });

  // Handle collection filter updates
  document.addEventListener('facet:update', function () {
    setTimeout(function () {
      document.querySelectorAll('collection-top-filter').forEach(function (element) {
        if (element.refresh) {
          element.refresh();
        }
      });

      // Also refresh visibility toggles
      document.querySelectorAll('collection-visibility-toggle').forEach(function (element) {
        if (element.applyGridLayout) {
          element.applyGridLayout();
        }
      });
    }, 200);
  });
});

// Global error handler for ajaxinate issues
window.addEventListener('error', function (e) {
  if (e.message && e.message.includes('ajaxinateContainer') && e.message.includes('classList')) {
    console.warn('Ajaxinate classList error caught and handled:', e.message);
    e.preventDefault();
  }
});

/**
 * Selling Plan Observer
 * Watches for hidden input[name="selling_plan"] being added to the DOM
 * and monitors changes to its value, then triggers the theme's existing change handlers
 */
(function () {
  var watchedInputs = new WeakSet();
  function notifySellingPlanChange(input, newValue) {
    console.log('Selling plan value changed to:', newValue);

    // Trigger native change event to notify theme's ProductFormReader
    // The theme's product-form component listens for these events
    var changeEvent = new Event('change', {
      bubbles: true
    });
    input.dispatchEvent(changeEvent);
    // Find the subscription selector and update visual state if needed
    var subscriptionSelector = document.querySelector('product-component [data-subscription-selectors]');
    if (subscriptionSelector) {
      // Update the selected radio button visual state
      var selectedPlanOption = subscriptionSelector.querySelector("[data-sellingplan-id=\"".concat(newValue, "\"]"));
      var allRadios = subscriptionSelector.querySelectorAll('input[type="radio"]');

      // Uncheck all radios first
      allRadios.forEach(function (radio) {
        return radio.checked = false;
      });

      // Check the matching radio if found
      if (selectedPlanOption) {
        var radio = selectedPlanOption.querySelector('input[type="radio"]');
        if (radio) {
          var _radio$closest, _radio$closest2, _radio$closest2$query;
          radio.checked = true;
          console.log((_radio$closest = radio.closest('.product__subs__group')) === null || _radio$closest === void 0 ? void 0 : _radio$closest.querySelector('.product__subs__option'));
          (_radio$closest2 = radio.closest('.product__subs__group')) === null || _radio$closest2 === void 0 ? void 0 : (_radio$closest2$query = _radio$closest2.querySelector('.product__subs__option')) === null || _radio$closest2$query === void 0 ? void 0 : _radio$closest2$query.click();
        }
      }
    }

    // Reapply recharge widget styles after selling plan change
    setTimeout(function () {
      if (window.applyRechargeWidgetStyles) {
        window.applyRechargeWidgetStyles();
      }
    }, 300);
  }
  function watchSellingPlanValue(input) {
    // Prevent duplicate watchers on the same input
    if (watchedInputs.has(input)) return;
    watchedInputs.add(input);
    console.log('Watching selling plan input:', input);

    // Create observer for value attribute changes
    var valueObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          var newValue = input.getAttribute('value');
          notifySellingPlanChange(input, newValue);
        }
      });
    });

    // Start observing attribute changes
    valueObserver.observe(input, {
      attributes: true,
      attributeFilter: ['value']
    });

    // Also listen for direct value property changes
    var currentValue = input.value;
    var checkValue = function checkValue() {
      if (input.value !== currentValue) {
        currentValue = input.value;
        notifySellingPlanChange(input, currentValue);
      }
    };

    // Check for value changes periodically
    var intervalId = setInterval(checkValue, 100);

    // Clean up when input is removed from DOM
    var disconnectObserver = new MutationObserver(function (mutations) {
      if (!document.body.contains(input)) {
        valueObserver.disconnect();
        disconnectObserver.disconnect();
        clearInterval(intervalId);
        console.log('Stopped watching removed selling plan input');
      }
    });
    disconnectObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Watch for hidden inputs with name="selling_plan" being added
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        // Check if the added node is the input itself
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.matches && node.matches('input[type="hidden"][name="selling_plan"]')) {
            watchSellingPlanValue(node);
          }

          // Check descendants
          if (node.querySelectorAll) {
            var inputs = node.querySelectorAll('input[type="hidden"][name="selling_plan"]');
            inputs.forEach(function (input) {
              return watchSellingPlanValue(input);
            });
          }
        }
      });
    });
  });

  // Start observing the document
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Check for existing inputs on load
  document.addEventListener('DOMContentLoaded', function () {
    var existingInputs = document.querySelectorAll('input[type="hidden"][name="selling_plan"]');
    existingInputs.forEach(function (input) {
      return watchSellingPlanValue(input);
    });
  });

  // Also check immediately in case DOM is already loaded
  if (document.readyState === 'loading') {
    // DOMContentLoaded will handle it
  } else {
    var existingInputs = document.querySelectorAll('input[type="hidden"][name="selling_plan"]');
    existingInputs.forEach(function (input) {
      return watchSellingPlanValue(input);
    });
  }
})();

/**
 * Recharge Subscription Widget Shadow DOM Style Observer
 * Watches for recharge-subscription-widget and modifies SVG height in shadow DOM
 * Stops trying after 30 seconds
 */
(function () {
  var found = false;
  var stopTime = Date.now() + 30000; // 30 seconds from now
  var checkInterval = null;
  function modifyRechargeWidgetStyles() {
    if (found || Date.now() > stopTime) {
      if (checkInterval) {
        clearInterval(checkInterval);
        checkInterval = null;
      }
      return;
    }
    try {
      var widget = document.querySelector('recharge-subscription-widget');
      if (!widget || !widget.shadowRoot) return;
      var radioIcons = widget.shadowRoot.querySelectorAll('rc-radio-icon');
      if (!radioIcons || radioIcons.length === 0) return;

      //remove USD from price display
      var prices = widget.shadowRoot.querySelectorAll('.rc-price');
      prices.forEach(function (price) {
        price.innerHTML = price.innerHTML.replace(/USD/g, '');
      });
      var anyModified = false;
      radioIcons.forEach(function (radioIcon) {
        if (!radioIcon.shadowRoot) return;
        var svg = radioIcon.shadowRoot.querySelector('svg');
        if (svg) {
          svg.style.width = "calc(1.15em + 1px)";
          svg.style.height = "calc(1.15em + 1px)";
          svg.style.marginRight = "1px";
          anyModified = true;
        }
      });
      if (anyModified) {
        found = true;
        console.log("Recharge widget SVG height modified successfully for ".concat(radioIcons.length, " radio icons"));
        if (checkInterval) {
          clearInterval(checkInterval);
          checkInterval = null;
        }
      }
    } catch (error) {
      console.warn('Error modifying recharge widget styles:', error);
    }
  }

  // Expose as global function that can be called anytime (ignoring timeout)
  window.applyRechargeWidgetStyles = function () {
    try {
      var widget = document.querySelector('recharge-subscription-widget');
      if (!widget || !widget.shadowRoot) return;

      // remove the price for all elements
      var prices = widget.shadowRoot.querySelectorAll('.rc-price');
      prices.forEach(function (price) {
        price.innerHTML = price.innerHTML.replace(/USD/g, '');
      });
      var radioIcons = widget.shadowRoot.querySelectorAll('rc-radio-icon');
      if (!radioIcons || radioIcons.length === 0) return;
      radioIcons.forEach(function (radioIcon) {
        if (!radioIcon.shadowRoot) return;
        var svg = radioIcon.shadowRoot.querySelector('svg');
        if (svg) {
          svg.style.width = "calc(1.15em + 1px)";
          svg.style.height = "calc(1.15em + 1px)";
          svg.style.marginRight = "1px";
        }
      });
      console.log("Recharge widget styles reapplied for ".concat(radioIcons.length, " radio icons"));
    } catch (error) {
      console.warn('Error applying recharge widget styles:', error);
    }
  };

  // Watch for the widget being added to DOM
  var observer = new MutationObserver(function (mutations) {
    if (found || Date.now() > stopTime) {
      observer.disconnect();
      if (checkInterval) {
        clearInterval(checkInterval);
        checkInterval = null;
      }
      return;
    }
    modifyRechargeWidgetStyles();
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also check periodically in case shadow DOM loads after element
  checkInterval = setInterval(modifyRechargeWidgetStyles, 100);

  // Stop everything after 30 seconds
  setTimeout(function () {
    observer.disconnect();
    if (checkInterval) {
      clearInterval(checkInterval);
      checkInterval = null;
    }
    if (!found) {
      console.log('Recharge widget style modification timed out after 30 seconds');
    }
  }, 30000);

  // Check immediately if widget already exists
  modifyRechargeWidgetStyles();
})();
function syncCustomerTypeToCart() {
  var _document$body, _document$body2, _document$body2$datas, _window$theme, _window$theme$routes;
  var customerType = ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.getAttribute('data-customer-type')) || ((_document$body2 = document.body) === null || _document$body2 === void 0 ? void 0 : (_document$body2$datas = _document$body2.dataset) === null || _document$body2$datas === void 0 ? void 0 : _document$body2$datas.customerType) || '';
  if (!customerType || !((_window$theme = window.theme) !== null && _window$theme !== void 0 && (_window$theme$routes = _window$theme.routes) !== null && _window$theme$routes !== void 0 && _window$theme$routes.cart_update_url)) {
    return;
  }
  fetch(window.theme.routes.cart_update_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        'Customer Type': customerType
      }
    })
  }).then(function (response) {
    if (!response.ok) {
      throw new Error("Cart update failed with status ".concat(response.status));
    }
    return response.text();
  }).then(function () {
    console.log('Customer type synced to cart via Upcart checkout flow:', customerType);
  })["catch"](function (error) {
    console.warn('Failed to sync customer type to cart:', error);
  });
}
document.addEventListener('DOMContentLoaded', syncCustomerTypeToCart, {
  once: true
});
setTimeout(function () {
  //sync with upcart bubble
  window.upcartSubscribeAddedToCart(function (event) {
    console.log("Added to cart:", event);

    // Update cart count bubble and sync B2B components
    syncCartWithUpcart();
  });
  window.upcartSubscribeCartUpdated(function (event) {
    console.log("Cart updated (after DOM changes):", event);

    // Update cart count bubble and sync B2B components
    syncCartWithUpcart();
  });
  window.upcartSubscribeCheckoutClicked(function (event) {
    console.log('Checkout clicked via Upcart:', event);
    syncCustomerTypeToCart();
  });

  // Helper function to sync cart count bubble and B2B components
  function syncCartWithUpcart() {
    return _syncCartWithUpcart.apply(this, arguments);
  }
  function _syncCartWithUpcart() {
    _syncCartWithUpcart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
      var response, cart, cartCountBubbles, cartToggles;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            _context12.next = 3;
            return fetch('/cart.js');
          case 3:
            response = _context12.sent;
            _context12.next = 6;
            return response.json();
          case 6:
            cart = _context12.sent;
            // Update cart count bubbles
            cartCountBubbles = document.querySelectorAll('[data-cart-count]');
            cartCountBubbles.forEach(function (bubble) {
              bubble.textContent = cart.item_count;
              if (cart.item_count > 0) {
                bubble.classList.remove('hidden');
              } else {
                bubble.classList.add('hidden');
              }
            });

            // Update cart toggle has-items class
            cartToggles = document.querySelectorAll('.cart__toggle');
            cartToggles.forEach(function (toggle) {
              if (cart.item_count > 0) {
                toggle.classList.add('cart__toggle--has-items');
              } else {
                toggle.classList.remove('cart__toggle--has-items');
              }
            });

            // Sync B2B components - dispatch cart sync event
            // The B2B component's handleCartSync will only re-render if quantity actually changed
            document.dispatchEvent(new CustomEvent('theme:cart:sync', {
              bubbles: true,
              detail: {
                cart: cart
              }
            }));
            console.log('Cart synced with Upcart:', cart.item_count);
            _context12.next = 18;
            break;
          case 15:
            _context12.prev = 15;
            _context12.t0 = _context12["catch"](0);
            console.error('Failed to sync cart:', _context12.t0);
          case 18:
          case "end":
            return _context12.stop();
        }
      }, _callee12, null, [[0, 15]]);
    }));
    return _syncCartWithUpcart.apply(this, arguments);
  }
}, 4000);

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/main": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/scss/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;